enum WorkerQualificationStatus {
    Pending = 10,
    Verified = 90

}

export default WorkerQualificationStatus;